export const awsConfiguration = {
  host: process.env.VUE_APP_IOT_ENDPOINT || '',
  apiVersion: process.env.VUE_APP_API_VERSION || 'Local',
  apiKey: 'AIzaSyDa6ZFf53TRQWAUad0vTl-2HZ5Hn82pf2c'
};

export const AppConfig = {
  Beta: process.env.VUE_APP_API_GATEWAY_URL || '',
  Prod: process.env.VUE_APP_API_GATEWAY_URL || '',
  RC: process.env.VUE_APP_API_GATEWAY_URL || ''
};
